import { Box, Button, FormLabel, Stack } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import { useDispatch } from 'react-redux';
import { useEffect, useState } from "react";
import { CAMPAIGN_BANNER_IMAGE_ALLOWED_TYPES, FORM_INPUTFIELD_STYLES } from "../../utils/constant";
import NormalInput from '../inputs/normalInput';
import { Field, FieldArray, Form, Formik, getIn } from 'formik';
import { createBrand, updateBrandbyId } from '../../pages/brands/action';
import Schema from '../../schema';
import imageIconWhite from '../../assets/images/icons/ImageIconWhite.svg'
import check from '../../assets/images/icons/greenCheck.svg'
import imageIcon from '../../assets/images/icons/imageIcon.svg'
import deleteIconRed from '../../assets/images/icons/deleteIconRed.svg'
import removeIcon from '../../assets/images/icons/removeIcon.svg'
import addIcon from '../../assets/images/icons/addIcon.svg'
import FormHeading from '../../utils/FormHeading';
const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  top: '0px',
  bottom: '0px',
  right: '0%',
  left: 'revert',
  border: '0px solid red',
  borderRadius: '16px', padding: '0px',
  backgroundRepeat: 'no-repeat',
  height: 'fit-content', width: 'fit-content',
  "& .MuiDialog-container": {
    margin: 0,
  },
  "& .MuiPaper-root": {
    margin: '0px !important',
    background: "white",
    border: '0px solid blue',
    borderRadius: '0px',
    maxWidth: '100dvw',
    maxHeight: '100dvh',
    height: '100dvh', scrollbarWidth: 'none', // For Firefox
    '&::-webkit-scrollbar': {
      display: 'none', // For Chrome, Safari, and Opera
    },
    [theme.breakpoints.down('sm')]: {
      width: '400px',
    },
    [theme.breakpoints.between('sm', 'md')]: {
      width: '500px',
    },
    [theme.breakpoints.between('md', 'lg')]: {
      width: '600px',
    },
    [theme.breakpoints.up('lg')]: {
      width: '700px',
    },
  },


}));


const CreateBrandModal = (props) => {
  const { open, setOpen, editedBrand = { product: [{ name: "" }], brandName: "", brandImage: "" } } = props;
  const handleClose = (resetForm) => {
    resetForm();
    setTimeout(() => {
      setOpen(false);
    }, 0);
  };

  const dispatch = useDispatch();
  const [bannerImageError, setBannerImageError] = useState("")
  const [initialValues, setInitialValues] = useState(editedBrand)
  const [preview, setPreview] = useState(editedBrand?.brandImage || "");
  useEffect(() => {
    setInitialValues(editedBrand)
    setPreview(editedBrand?.brandImage)
  }, [editedBrand])

  return (
    <>

      <Formik
        initialValues={initialValues}
        validationSchema={Schema.BrandsForCompany}
        enableReinitialize
        onSubmit={(values, { resetForm }) => {
          values['product'] = JSON.stringify(values['product'])
          const { brandName, product, brandImage } = values;
          const formData = new FormData();
          formData.append("brandName", brandName)
          formData.append("product", product)
          formData.append("brandImage", brandImage)
          if (initialValues?.id) dispatch(updateBrandbyId(formData, initialValues?.id))
          else dispatch(createBrand(formData));
          resetForm();
          setOpen(false)
        }}
      >
        {({
          errors,
          handleBlur,
          handleChange,
          touched,
          values,
          resetForm,
        }) => {

          const handleDrop = (e) => {
            e.preventDefault();
            const file = e.dataTransfer.files[0];
            handleFile(file);
            e.target.value = null;
          };
          const handleFileChange = (e) => {
            const file = e.target.files[0];
            handleFile(file);
            e.target.value = null;
          };

          const handleFile = async (file) => {
            if (!file) return;
            if (!CAMPAIGN_BANNER_IMAGE_ALLOWED_TYPES.includes(file.type)) {
              setBannerImageError('Invalid file format. Please upload a JPEG or PNG image.')
              return;
            }
            setBannerImageError("")
            const img = new Image();
            const reader = new FileReader();

            reader.onload = (e) => {
              img.src = e.target.result;

              img.onload = async () => {
                setBannerImageError("");
                const base64 = e.target.result;
                setPreview(base64);

                handleChange({
                  target: {
                    name: "brandImage",
                    value: file,
                  }
                })
              };
            };

            reader.readAsDataURL(file);
          };
          const handleDeleteBannerImage = (e) => {
            e.preventDefault();
            e.stopPropagation();
            handleChange({
              target: {
                name: "brandImage",
                value: "",
              }
            })
            setPreview(null);
          }


          return (
            <BootstrapDialog
              onClose={() => handleClose(resetForm)}
              aria-labelledby="customized-dialog-title ccc"
              open={open}
            >
              <Form style={{ height: '100%' }}>
                <Box sx={{ paddingX: '0px', height: '100%', position: 'relative' }}>
                  <Box sx={{ height: '10%' }}>
                    <Typography sx={{ fontSize: '20px', fontWeight: 600, color: 'black', padding: '20px 23px', borderBottom: '1px solid #F0F0F0', }}>
                      {initialValues?.id ? "Edit Brand" : "Create Brand"}

                    </Typography>

                  </Box>
                  <Box sx={{
                    padding: 0, minHeight: '82%', maxHeight: '82%', height: '82%', overflowX: 'hidden', overflowY: 'scroll', scrollbarWidth: 'none', zIndex: 1,
                    '&::-webkit-scrollbar': {
                      display: 'none',
                    }
                  }}>


                    <Box sx={{ padding: '24px', paddingTop: 0, }}>
                     <FormHeading heading="Brand Name" isRequired={true} />
                      <NormalInput
                        name={"brandName"}
                        style={FORM_INPUTFIELD_STYLES}
                        type={"text"}
                        focused={false}
                        label={("")}
                        sizeval="medium"
                        values={values.brandName}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={Boolean(touched.brandName) && errors.brandName}
                        helperText={touched.brandName && errors.brandName}
                      />

                    </Box>

                    <Box sx={{ padding: '24px', paddingTop: 0, }}>
                     <FormHeading heading="Brand Banner" isRequired={true} />
                      <Box
                        onDrop={handleDrop}
                        onDragOver={(e) => e.preventDefault()}
                        sx={{
                          border: '1px dashed #E5E5E5',
                          borderRadius: '16px',
                          padding: '16px',
                          textAlign: 'center',
                          cursor: 'pointer',
                          background: '#FAFAFA',
                          position: 'relative',
                          width: '100%', height: '150px'
                        }}>
                        <input
                          type="file"
                          accept="image/*"
                          id="fileInput"
                          style={{ display: 'block', height: '100%', width: '100%', border: '2px solid red', opacity: 0 }}
                          onChange={handleFileChange}
                        />
                        <label htmlFor="fileInput" style={{ width: '100%', height: '100%', position: 'absolute', top: 0, left: 0, padding: '16px', cursor: 'pointer' }}>
                          {preview ? (
                            <Stack
                              direction="row" justifyContent="flex-start" gap={1.5} alignItems="center"
                              sx={{
                                width: '100%',
                                height: '100%',
                                borderRadius: 2,
                                border: '0px solid red'
                              }}>
                              <Stack direction="row" justifyContent="flex-start" alignItems="center" gap={2} sx={{ height: '100px', width: '90%', background: '#F0F0F0', borderRadius: '10px', padding: '14px' }}>
                                <Box sx={{ height: '65px', width: '65px', position: 'relative' }}>
                                  <img src={preview} alt="preview" style={{ height: '100%', width: '100%', objectFit: 'cover', borderRadius: '5px' }} />
                                  <div style={{ position: 'absolute', top: 0, left: 0, background: 'rgba(0,0,0,0.5)', height: '100%', width: '100%', padding: '17px', borderRadius: '5px' }}>
                                    <img src={imageIconWhite} alt="imageIconWhite" style={{ height: '24px', width: '24px' }} />
                                  </div>
                                </Box>
                                <Typography sx={{ color: '#726C6C', fontSize: '14px', fontWeight: 400, minWidth: '200px', textAlign: 'left' }}>{values?.brandImage?.name?.substring(0, 30) || "Banner Image"}</Typography>
                                <img src={check} alt="check" style={{ height: '24px', width: '24px' }} />
                              </Stack>
                              <Button sx={{ "&:hover": { background: 'transparent' } }} disableRipple onClick={handleDeleteBannerImage}><img src={deleteIconRed} alt="check" style={{ height: '24px', width: '24px' }} /></Button>
                            </Stack>
                          ) : (
                            <>
                              <img src={imageIcon} alt="" style={{ height: '32px', width: '32px' }} />
                              <Typography variant="body1" sx={{ mt: 0.7, fontSize: '12px', fontWeight: 600 }}>
                                <span style={{ color: 'var(--color-blue)', textDecoration: 'underline', }}>
                                  Click to upload
                                </span>{' '}
                                or drag and drop
                              </Typography>
                              <Typography variant="caption" sx={{ mt: 0.7, display: 'block', color: '#A3A3A3', fontSize: '10px', fontWeight: 400, }}>
                                {/* Supported dimensions (pixels) are 1920 x 1080,1280 x 720 and 1024 x 576. Image formats like JPEG and PNG */}
                                Supported dimensions (pixels) are 300x300 and 180x180. Image formats like JPEG and PNG
                              </Typography>
                              {bannerImageError && (<Typography sx={{ mt: 0.7, display: 'block', color: 'var(--red)', fontSize: '10px', fontWeight: 400, }}>
                                {bannerImageError}
                              </Typography>)}
                              {errors.brandImage && touched.brandImage && (
                                <Typography sx={{ mt: 0.7, display: 'block', color: 'var(--red)', fontSize: '10px', fontWeight: 400, }}
                                  className="error"

                                >
                                  {`${errors?.brandImage}`}
                                </Typography>
                              )}
                            </>
                          )}
                        </label>
                      </Box>

                    </Box>
                    <Box sx={{ padding: '24px', paddingTop: 0, }}>
                      <FieldArray
                        name={`product`}
                        render={(array) => (
                          <>{values?.product?.length && values?.product?.map(
                            (post, index) => (
                              <>

                                <div className="row mb-3">
                                  <div className="col-xxl-11 col-xl-11 col-lg-11 col-md-11 col-sm-11 col-11">
                                    <FormHeading heading={`Product Name. ${index + 1}`} isRequired={true} />
                                    <NormalInput
                                      style={FORM_INPUTFIELD_STYLES}
                                      name={`product.[${index}].name`}
                                      type={"text"}
                                      focused={false}
                                      label={("")}
                                      sizeval="medium"
                                      values={
                                        values.product[index].name
                                      }
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                    />

                                    <Field
                                      name={`product.[${index}].name`}
                                      render={({ form }) => {
                                        const error = getIn(
                                          form.errors,
                                          `product.[${index}].name`,
                                        );
                                        const touch = getIn(
                                          form.touched,
                                          `product.[${index}].name`,
                                        );
                                        return touch && error ? (
                                          <p className="error">
                                            {error}
                                          </p>
                                        ) : null;
                                      }}
                                    />
                                  </div>
                                  <div className="col-xxl-1 col-xl-1 col-lg-1 col-md-1 col-sm-1 col-1 p-0">
                                    {index === values.product.length - 1 ? <img src={addIcon} onClick={() => {
                                      array.push({
                                        name: ""
                                      });
                                    }} alt="plus" width={"24"} height={'24'} style={{ cursor: 'pointer', marginTop: '32px' }} /> : <img src={removeIcon}
                                      onClick={(e) => {
                                        e.preventDefault();
                                        array.remove(index);
                                      }} alt="minus" width={"24"} height={'24'} style={{ cursor: 'pointer', marginTop: '32px' }} />}
                                  </div>
                                </div>
                              </>
                            ))}
                          </>
                        )}
                      />
                    </Box>
                  </Box>

                  <Stack direction="row" justifyContent="flex-end" alignItems="center" gap={2} sx={{ paddingX: '20px', height: '8%', position: 'sticky', bottom: 0, left: 0, right: 0, }}>
                    <Button sx={{ padding: '15px 50px', border: '1px solid white', boxSizing: 'border-box', borderRadius: '6px', color: 'black', "&:hover": { border: '1px solid #BDBDBD', boxSizing: 'border-box', background: 'white' } }} onClick={() => setOpen(false)}>Cancel</Button>
                    <Button sx={{ padding: '15px 50px', borderRadius: '6px', background: 'var(--color-blue)', color: 'white', "&:hover": { background: 'var(--color-blue)' } }} type="submit">{initialValues.id ? "Update" : "Create"}</Button>
                  </Stack>
                </Box>

              </Form>
            </BootstrapDialog>
          );
        }}
      </Formik>
    </>
  )
}

export default CreateBrandModal;